'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import FavoritesRouter from '../favorites/FavoritesRouter';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import FavoritesRenderer from '../favorites/FavoritesRenderer';
import { ServerVarsContextProvider } from '../sharedComponents/ServerVarsContext';

// Helpers
// todo: remove as soon as we get rid of fluxible
import serverVars from 'server-vars';
import FavoritesReducers from '../favorites/reducers/FavoritesReducers';
import getInitialState from '../favorites/FavoritesInitialState';
import { cutoffs, sortBy, tabs, viewModes } from '../favorites/constants';
import { favoritesCallouts } from '../favorites/components/FavoriteCallouts/favoritesCalloutConfig';

const { preloadedData, preloadedState } = serverVars.get('favorites') || {};
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
const initialState = preloadedState || getInitialState({});
const userId = getBuyerId(document.cookie) || '';
const {
    first,
    portfolioIds,
    portfolioTypes,
    portfolioViewPermission,
    projectId,
    tab,
} = initialState.favorites.uiState;
const isFolder = tab === tabs.FOLDER && portfolioViewPermission;
const isProject = tab === tabs.PROJECT;
const rendererProps = {
    after: null,
    first,
    followingFirst: cutoffs.FOLLOWING_ITEMS,
    hasUserId: !!userId,
    portfolioIds,
    portfolioTypes,
    projectId,
    selectedItems: [],
    showSeller: !!userId,
    sortBy: sortBy.CUSTOM,
    foldersSort: sortBy.CUSTOM,
    loadPortfolioData: !!userId,
    selectedItemIds: [],
    tab,
    isDiscover: tab === tabs.DISCOVER,
    isItems: tab === tabs.ITEMS,
    isFolders: tab === tabs.FOLDERS,
    isFollowing: tab === tabs.FOLLOWING,
    isSinglePortfolio: isFolder || isProject,
    isProjects: tab === tabs.PROJECTS,
    isTrade: getUserType(document.cookie) === 'trade',
    userHasChanged: false,
    useProjectEndpoint: !!projectId,
    userId,
    userIds: [userId],
    viewMode: viewModes.GRID,
    ...preloadedData,
};

const options = {
    notifications: favoritesCallouts[tab],
    state: initialState,
    reducers: FavoritesReducers,
};

initializeDBL(options).then(({ store, queue }) => {
    const router = new FavoritesRouter({ store, queue });

    router.history.start({
        silent: true,
        pushState: true,
        root: '/favorites/',
    });

    ReactDOM.hydrate(
        <IntlProvider
            locale={serverVars.get('localeDataKey')}
            messages={serverVars.get('messages')}
        >
            <ServerVarsContextProvider
                isMobile={serverVars.get('settings.isMobile')}
                isTablet={serverVars.get('settings.isTablet')}
                isDesktop={serverVars.get('settings.isDesktop')}
            >
                <Provider store={store}>
                    <FavoritesRenderer {...rendererProps} />
                </Provider>
            </ServerVarsContextProvider>
        </IntlProvider>,
        document.getElementById('js-root')
    );
});
